import { parametroContabilDetalhesStyles } from './ParametroContabilDetalhes.style'

export function parametroContabilDetalhesIO() {
  return {
    styles: parametroContabilDetalhesStyles
  }
}

export type ParametroContabilDetalhesIO = ReturnType<typeof parametroContabilDetalhesIO>
